/* eslint-disable camelcase */
/* eslint-disable no-extend-native */
const { objectId } = require('./objectid')
const { PMT, PV, FV, NPER, RATE } = require('./runtime/finance')

// utility function
// function typeOf(obj) {
//     return ({}).toString.call(obj).match(/\s([a-z|A-Z]+)/)[1].toLowerCase();
// }

// extend String prototype
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function (find, replaceWith) {
      const escRE = /[.*+?^${}()|[\]\\]/g
      return this.replace(new RegExp(find.replace(escRE, '\\$&'), 'g'), replaceWith)
    }
  })
}
if (!String.prototype.strip) {
  Object.defineProperty(String.prototype, 'strip', {
    value: function (characters, fromStart = true, fromEnd = true) {
      let s = 0; let e = this.length - 1
      if (fromStart) {
        while (characters.includes(this[s]) && (s <= e)) { s++ }
      }
      if (fromEnd) {
        while (characters.includes(this[e]) && (e >= s)) { e-- }
      }
      return this.substring(s, e + 1)
    }
  })
}
if (!String.prototype.first) {
  Object.defineProperty(String.prototype, 'first', {
    value: function (count) {
      return this.substring(0, count) // Number.parseInt(count))
    }
  })
}
if (!String.prototype.last) {
  Object.defineProperty(String.prototype, 'last', {
    value: function (count) {
      count = Number.parseInt(count)
      return (isNaN(count) || count <= 0) ? '' : this.slice(-count)
    }
  })
}
if (!String.prototype.toInt) {
  Object.defineProperty(String.prototype, 'toInt', {
    value: function () {
      return Number.parseInt(this)
    }
  })
}
if (!String.objectId) {
  Object.defineProperty(String, 'objectId', {
    value: objectId
  })
}
if (!String.random) {
  Object.defineProperty(String, 'random', {
    value: function (length, chars = 'aA#') {
      var mask = '', result = ''
      if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz'
      if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      if (chars.indexOf('#') > -1) mask += '0123456789'
      if (chars.indexOf('!') > -1) mask += '~!@#$%^&()_+-={}[];,'
      while (length-- > 0) {
        result += mask[Math.floor(Math.random() * mask.length)]
      }
      return result
    }
  })
}
if (!String.urlEncode) {
  Object.defineProperty(String, 'urlEncode', {
    value: function (text) {
      return encodeURIComponent(text)
        .replaceAll('(', '%28')
        .replaceAll(')', '%29')
    }
  })
}
if (!String.urlDecode) {
  Object.defineProperty(String, 'urlDecode', {
    value: decodeURIComponent
  })
}

function WrapMod (mod) {
  if ('__esModule' in mod) {
    return mod.default
  } // else
  return mod
}

// extend Date prototype

const date_StartOfDay = WrapMod(require('date-fns/startOfDay'))
const date_DifferenceInYears = WrapMod(require('date-fns/differenceInYears'))
const date_DifferenceInMonths = WrapMod(require('date-fns/differenceInMonths'))
const date_DifferenceInCalendarDays = WrapMod(require('date-fns/differenceInCalendarDays'))
const date_StartOfToday = WrapMod(require('date-fns/startOfToday'))
const date_IsEqual = WrapMod(require('date-fns/isEqual'))
const date_IsBefore = WrapMod(require('date-fns/isBefore'))
const date_IsAfter = WrapMod(require('date-fns/isAfter'))
const date_Parse = WrapMod(require('date-fns/parseISO'))
const date_AddDays = WrapMod(require('date-fns/addDays'))
const date_AddWeeks = WrapMod(require('date-fns/addWeeks'))
const date_AddMonths = WrapMod(require('date-fns/addMonths'))
const date_AddYears = WrapMod(require('date-fns/addYears'))
const date_SubDays = WrapMod(require('date-fns/subDays'))
const date_SubWeeks = WrapMod(require('date-fns/subWeeks'))
const date_SubMonths = WrapMod(require('date-fns/subMonths'))
const date_SubYears = WrapMod(require('date-fns/subYears'))
const date_GetDate = WrapMod(require('date-fns/getDate'))
const date_GetDay = WrapMod(require('date-fns/getDay'))
const date_GetMonth = WrapMod(require('date-fns/getMonth'))
const date_GetYear = WrapMod(require('date-fns/getYear'))

if (!Date.prototype.isEqualTo) {
  Object.defineProperty(Date.prototype, 'isEqualTo', {
    value: function (that) {
      return date_IsEqual(date_StartOfDay(this), date_StartOfDay(that))
    }
  })
}
if (!Date.prototype.isNotEqualTo) {
  Object.defineProperty(Date.prototype, 'isNotEqualTo', {
    value: function (that) {
      return !this.isEqualTo(that)
    }
  })
}
if (!Date.prototype.isBefore) {
  Object.defineProperty(Date.prototype, 'isBefore', {
    value: function (that) {
      return date_IsBefore(date_StartOfDay(this), date_StartOfDay(that))
    }
  })
}
if (!Date.prototype.isNotBefore) {
  Object.defineProperty(Date.prototype, 'isNotBefore', {
    value: function (that) {
      return !this.isBefore(that)
    }
  })
}
if (!Date.prototype.isAfter) {
  Object.defineProperty(Date.prototype, 'isAfter', {
    value: function (that) {
      return date_IsAfter(date_StartOfDay(this), date_StartOfDay(that))
    }
  })
}
if (!Date.prototype.isNotAfter) {
  Object.defineProperty(Date.prototype, 'isNotAfter', {
    value: function (that) {
      return !this.isAfter(that)
    }
  })
}

function WrapDateCalc (func) {
  return function (d, num) {
    if (d !== null && typeof d === 'object' && d.constructor.name === 'Date' && num !== null && num !== undefined) {
      const n = num.valueOf()
      if (isFinite(d.valueOf()) && typeof n === 'number' && isFinite(n)) {
        return func(d, num)
      }
    }
    // else returns undefined
  }
}

// date helper object
exports.date = {
  parse: date_Parse,
  today: function (offsetHours) {
    if (offsetHours) {
      const base = new Date() // now
      const newBase = new Date(base.getTime() + 6e4 * (60 * offsetHours + base.getTimezoneOffset()))
      return date_StartOfDay(newBase)
    } // else
    return date_StartOfToday()
  },
  addDays: WrapDateCalc(date_AddDays),
  addWeeks: WrapDateCalc(date_AddWeeks),
  addMonths: WrapDateCalc(date_AddMonths),
  addYears: WrapDateCalc(date_AddYears),
  subDays: WrapDateCalc(date_SubDays),
  subWeeks: WrapDateCalc(date_SubWeeks),
  subMonths: WrapDateCalc(date_SubMonths),
  subYears: WrapDateCalc(date_SubYears),
  age: function (birth) { return date_DifferenceInYears(date_StartOfToday(), date_StartOfDay(birth)) },
  new: function (year, month, day) { return date_StartOfDay(new Date(year, month - 1, day)) },
  dayOf: date_GetDate,
  dayOfWeek: date_GetDay,
  daysBetween: date_DifferenceInCalendarDays,
  monthOf: function (date) { return date_GetMonth(date) + 1 },
  monthsBetween: date_DifferenceInMonths,
  yearOf: date_GetYear,
  yearsBetween: date_DifferenceInYears,
}

// math helper object
exports.math = Math

// text helper object
exports.text = String

function equalWithTolerance (num1, num2, tolerance) {
  return Math.abs(num1 - num2) < Math.pow(10, tolerance)
}

// number helper object
// exports.number = Number
exports.number = {
  EPSILON: Number.EPSILON,
  MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
  MAX_VALUE: Number.MAX_VALUE,
  MIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
  MIN_VALUE: Number.MIN_VALUE,
  NaN: Number.NaN,
  NEGATIVE_INFINITY: Number.NEGATIVE_INFINITY,
  POSITIVE_INFINITY: Number.POSITIVE_INFINITY,
  isFinite: Number.isFinite,
  isInteger: Number.isInteger,
  isNaN: Number.isNaN,
  isSafeInteger: Number.isSafeInteger,
  parseFloat: Number.parseFloat,
  parseInt: Number.parseInt,
  equal: function (num1, num2, tolerance = -10) {
    return equalWithTolerance(num1, num2, tolerance)
  },
  notEqual: function (num1, num2, tolerance = -10) {
    return !equalWithTolerance(num1, num2, tolerance)
  },
  lessThan: function (num1, num2, tolerance = -10) {
    return !equalWithTolerance(num1, num2, tolerance) && (num1 < num2)
  },
  lessOrEqual: function (num1, num2, tolerance = -10) {
    return equalWithTolerance(num1, num2, tolerance) || (num1 < num2)
  },
  greaterThan: function (num1, num2, tolerance = -10) {
    return !equalWithTolerance(num1, num2, tolerance) && (num1 > num2)
  },
  greaterOrEqual: function (num1, num2, tolerance = -10) {
    return equalWithTolerance(num1, num2, tolerance) || (num1 > num2)
  },
}

// finance helper object
exports.finance = {
  PMT: PMT,
  PV: PV,
  FV: FV,
  NPER: NPER,
  RATE: RATE,
}

// global "peek" function
exports.peek = value => value
